import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";
import { ActivatedRoute, Router } from "@angular/router";
import { forkJoin, Observable } from "rxjs";
import { LocalStorageService } from "../../../shared/local-storage.service";
import { Helicopter } from "../../../shared/models/helicopter.model";
import { HtlBlock } from "../../../shared/models/htlBlock.model";
import { HelicoptersService } from "../../../helicopters/helicopters.service";
import { HtlService } from "../../htl.service";
import moment from "moment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-update-htl-block",
    templateUrl: "./update-htl-block.component.html",
    styleUrls: ["./update-htl-block.component.scss"],
    standalone: false,
})
export class UpdateHtlBlockComponent implements OnInit {
    public htlBlockFormGroup: FormGroup;
    public helicopterAttr;
    public displayedColumns: string[] = ["lubricants", "type", "manufacturer"];
    public helicopter: Helicopter;
    public organizationId;

    private _userSession;
    private _params;

    @HostListener("window:beforeunload", ["$event"])
    beforeunload($event) {
        if (this.htlBlockFormGroup.touched) {
            return ($event.returnValue = "Do you want to Leave this page?");
        }
        return ($event.returnValue = "Test");
    }

    constructor(
        private _htlService: HtlService,
        private _formBuilder: FormBuilder,
        private _localStorageService: LocalStorageService,
        private _route: ActivatedRoute,
        private _helicoptersService: HelicoptersService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _router: Router,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
        this._params = this._route.snapshot.params;
        this.htlBlockFormGroup = this._formBuilder.group({
            id: [""],
            blockSerialNumber: ["", Validators.required],
            enacRegistrationNumber: ["", Validators.required],
            campoPh: [""],
            issueDate: ["", Validators.required],
            engineOilType: ["", Validators.required],
            engineOilManufacturer: ["", Validators.required],
            mgboilType: ["", Validators.required],
            mgboilManufacturer: ["", Validators.required],
            tgbOilType: ["", Validators.required],
            tgbOilManufacturer: ["", Validators.required],
            hydraulicFluidType: ["", Validators.required],
            hydraulicFluidManufacturer: ["", Validators.required],
            htlNumber: ["", Validators.required],
            operator: [{ value: "", disabled: true }, Validators.required],
            helicopterType: [{ value: "", disabled: true }, Validators.required],
            helicopterRegistrationMark: [{ value: "", disabled: true }, Validators.required],
            helicopterSerialNumber: [{ value: "", disabled: true }, Validators.required],
            startedOn: ["", Validators.required],
            airframeStartedOnTotalTime: ["0:00", [Validators.required, Validators.pattern(/^((0|[1-9][0-9]*):[0-5]\d$)$/g)]],
            upTo: [""],
            airframeUpToTotalTime: ["0:00", Validators.pattern(/^((0|[1-9][0-9]*):[0-5]\d$)$/g)],
            helicopterId: [this._params.registrationMark.split("-")[0], Validators.required],
            organizationId: [this._userSession.organizationId, Validators.required],
        });
        this.organizationId = this._userSession.organizationId;
    }

    ngOnInit(): void {
        const obsArray = [];
        const heliId = this._params.registrationMark.split("-")[0];
        if (!this._htlService.helicopterAttributes) {
            obsArray.push(this._helicoptersService.getHelicopterAttributes(this._userSession.organizationId));
        } else {
            this.helicopterAttr = this._htlService.helicopterAttributes;
        }
        if (!this._htlService.helicopters) {
            obsArray.push(this._helicoptersService.getHelicopters(this._userSession.organizationId));
        } else {
            this.helicopter = this._htlService.helicopters.filter((r) => r.id.toString() === heliId.toString())[0];
        }
        if (obsArray.length > 0) {
            forkJoin(obsArray).subscribe(
                (result: any) => {
                    this.helicopterAttr = result[0];
                    this.helicopter = result[1].filter((r) => r.id.toString() === heliId.toString())[0];
                },
                (error) => {},
                () => {
                    console.log(this.helicopter);
                    this.populateEmptyHtlBlockForm();
                },
            );
        } else {
            this.populateEmptyHtlBlockForm();
        }
    }

    populateEmptyHtlBlockForm() {
        if (this._params.blockId) {
            this._htlService.getHtlBlockById(this._params.blockId).subscribe((result) => {
                console.log(result);
                result.operator = result.operator ? result.operator : this._getHelicopterOperatorName(this.helicopter.operatorId);
                result.helicopterType = result.helicopterType ? result.helicopterType : this._getHelicopterType(this.helicopter.helicopterTypeId).name;
                result.helicopterRegistrationMark = result.helicopterRegistrationMark ? result.helicopterRegistrationMark : this.helicopter.registrationMark;
                result.helicopterSerialNumber = result.helicopterSerialNumber ? result.helicopterSerialNumber : this.helicopter.serialNumber;
                this.htlBlockFormGroup.patchValue(result);
            });
        } else {
            const engineOilType = this.helicopterAttr.oilTypes.filter((o) => o.id === this.helicopter.engineOilTypeId)[0];
            const mgboilType = this.helicopterAttr.oilTypes.filter((o) => o.id === this.helicopter.mgbOilTypeId)[0];
            const tgbOilType = this.helicopterAttr.oilTypes.filter((o) => o.id === this.helicopter.tgbOilTypeId)[0];
            const hydraulicFluidType = this.helicopterAttr.hydraulicFluidTypes.filter((o) => o.id === this.helicopter.hydraulicFluidTypeId)[0];
            console.log(this._getHelicopterType(this.helicopter.helicopterTypeId).name);
            this.htlBlockFormGroup.patchValue({
                engineOilType: engineOilType.name,
                engineOilManufacturer: this._getOilManufacturer(engineOilType.oilTypeManufacturerId).name,
                mgboilType: mgboilType.name,
                mgboilManufacturer: this._getOilManufacturer(mgboilType.oilTypeManufacturerId).name,
                tgbOilType: tgbOilType.name,
                tgbOilManufacturer: this._getOilManufacturer(tgbOilType.oilTypeManufacturerId).name,
                hydraulicFluidType: hydraulicFluidType.name,
                hydraulicFluidManufacturer: this._getHydraulicFluidManufacturer(hydraulicFluidType.id).name,
                operator: this._getHelicopterOperatorName(this.helicopter.operatorId),
                helicopterType: this._getHelicopterType(this.helicopter.helicopterTypeId).name,
                helicopterRegistrationMark: this.helicopter.registrationMark,
                helicopterSerialNumber: this.helicopter.serialNumber,
            });
        }
    }

    onFormSubmit() {
        if (this.htlBlockFormGroup.valid) {
            const htlBlockObject = { ...this.htlBlockFormGroup.getRawValue() } as HtlBlock;
            htlBlockObject.issueDate = moment(htlBlockObject.issueDate).format("YYYY-MM-DD");
            htlBlockObject.startedOn = moment(htlBlockObject.startedOn).format("YYYY-MM-DD");
            htlBlockObject.upTo = moment(htlBlockObject.upTo).format("YYYY-MM-DD");
            let observable: Observable<HtlBlock>;
            if (!this._params.blockId) {
                observable = this._htlService.insertHtlBlock(htlBlockObject);
            } else {
                observable = this._htlService.updateHtlBlock(htlBlockObject);
            }
            observable.subscribe(() => {
                this._router.navigate(["/atl", this._htlService.currentRegistrationMark, "blocks"]);
                this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                    duration: 3000,
                });
            });
        }
    }

    private _getOilManufacturer(oilTypeManufacturerId: number): { id: number; name: string } {
        return this.helicopterAttr.oilManufacturers.filter((o) => o.id === oilTypeManufacturerId)[0];
    }

    private _getHydraulicFluidManufacturer(hydraulicFluidTypeManufacturerId: number): { id: number; name: string } {
        return this.helicopterAttr.hydraulicFluidTypeManufacturers.filter((o) => o.id === hydraulicFluidTypeManufacturerId)[0];
    }

    private _getHelicopterType(helicopterTypeId: number): { id: number; name: string } {
        return this.helicopterAttr.helicopterTypes.filter((h) => h.id === helicopterTypeId)[0];
    }

    private _getHelicopterOperatorName(operatorId: number): string {
        return this.helicopterAttr.operators.filter((o) => o.id === operatorId)[0].name;
    }

    onOilTypeChange(event: MatSelectChange, formControlName: string) {
        const engineOilTypeObject = this.helicopterAttr.oilTypes.filter((o) => o.name.toLowerCase() === event.value.toLowerCase())[0];
        const oilManufacturer = this._getOilManufacturer(engineOilTypeObject.oilTypeManufacturerId);
        const formObject = {};
        formObject[formControlName] = oilManufacturer.name;
        this.htlBlockFormGroup.patchValue(formObject, { emitEvent: true });
    }

    onHydraulicFluidChange(event: MatSelectChange, formControlName: string) {
        const hydraulicFluidTypeObject = this.helicopterAttr.hydraulicFluidTypes.filter((o) => o.name.toLowerCase() === event.value.toLowerCase())[0];
        const hydraulicFluidTypeManufacturer = this._getHydraulicFluidManufacturer(hydraulicFluidTypeObject.hydraulicFluidTypeManufacturerId);
        const formObject = {};
        formObject[formControlName] = hydraulicFluidTypeManufacturer.name;
        this.htlBlockFormGroup.patchValue(formObject, { emitEvent: true });
    }
}
